





























































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { bus } from "../../main";
import * as user from "../../_store/user.module";
@Component
export default class GeneraDocDialog extends Vue {
  @Prop() idRichiesta!: number;
  @Prop() activityType!: string;
  @Prop() info!: any;

  private dialog: boolean;
  private enableTextFields: boolean;
  private addData: string;
  private dateTemp: string;
  private giornoMenu: boolean;
  private numeroProtocollazione: string;
  private userInfo: any;

  constructor() {
    super();
    this.dialog = false;
    this.enableTextFields = false;
    this.addData = ""; //this.info.dataProtocollazione
    this.dateTemp = new Date().toISOString().substr(0, 10);
    this.giornoMenu = false;
    this.numeroProtocollazione = ""; //this.info.numeroProtocollazione
  }

  @Watch("dateTemp")
  onDateTempChange() {
    this.dateFilter();
  }

  dateFilter() {
    const date = new Date(this.dateTemp);
    this.addData = date.toLocaleString(["it-IT"], {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    });
  }

  close() {
    this.dialog = false;
    this.addData = this.info.dataProtocollazione;
    this.numeroProtocollazione = this.info.numeroProtocollazione;
    this.dateFilter();
  }

  confirmAssignment() {
    var payload = {
      idRichiesta: this.idRichiesta,
      activityType: this.activityType,
      numeroProtocollazione: this.numeroProtocollazione,
      dataProtocollazione: this.dateTemp
    };
    var payload2 = {
      emailAzienda: this.info.emailAzienda,
      emailTirocinante: this.info.emailUtente,
      denominazioneAzienda: this.info.denominazioneAzienda,
      tirocinante: this.info.allievo,
      activityType: this.activityType
    };
    
    user
      .dispatchConfirmAbbinamento(this["$store"], payload)
      .then(() => {
        user
          .dispatchGeneraDocumenti(this["$store"], payload)
          .then(() => {
            bus.$emit(
              "successfullOperation",
              "Abbinamento confermato e documenti generati con successo "
            );
            if (this.activityType === "tirocinioFormativo") {
              user
                .dispatchSendEmailDocGenerati(this["$store"], payload2)
                .then(() => {
                  bus.$emit("loadPreAssegnazioni");
                })
                .catch(error => {
                  if (error.response.status === 403) {
                    bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                    this["$router"].push("/login");
                  } else {
                    bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                  }
                });
            } else if (this.activityType === "tirocinioEstivo") {
              // user
              //   .dispatchSendEmailDocGenerati(this["$store"], payload2)
              //   .then(() => {
              //     bus.$emit("loadPreAssegnazioni");
              //   })
              //   .catch(error => {
              //     if (error.response.status === 403) {
              //       bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              //       this["$router"].push("/login");
              //     } else {
              //       bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              //     }
              //   });
            } else if (this.activityType === "alternanza") {
              // user
              //   .dispatchSendEmailDocGenerati(this["$store"], payload2)
              //   .then(() => {
              //     bus.$emit("loadPreAssegnazioni");
              //   })
              //   .catch(error => {
              //     if (error.response.status === 403) {
              //       bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              //       this["$router"].push("/login");
              //     } else {
              //       bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              //     }
              //   });
            } else if (this.activityType === "tirocinioReIns") {
              user
                .dispatchSendEmailDocGenerati(this["$store"], payload2)
                .then(() => {
                  bus.$emit("loadPreAssegnazioni");
                })
                .catch(error => {
                  if (error.response.status === 403) {
                    bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                    this["$router"].push("/login");
                  } else {
                    bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                  }
                });
            }
          })
          .catch(error => {
            if (error.response.status === 403) {
              bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              this["$router"].push("/login");
            } else {
              bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            }
          });
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  created() {
    this.userInfo = user.readUserInfo(this["$store"])
    if (
      this.activityType === "tirocinioFormativo" ||
      this.activityType === "tirocinioReIns" ||
      this.activityType === "alternanza"
    ) {
      this.enableTextFields = true;
    }
    if (this.info.numeroProtocollazione !== null && this.info.numeroProtocollazione !== undefined){
      this.numeroProtocollazione = this.info.numeroProtocollazione;
    }
    if (this.info.dataProtocollazione !== null && this.info.dataProtocollazione !== undefined){
      this.addData = this.info.dataProtocollazione;
      this.dateTemp = this.addData;
    }
    this.dateFilter();
  }
}
